import { create } from 'zustand';
import type { SessionPhase } from '../types/typing';

/**
 * Zustand holds only UI-visible state: phase, metrics, snippetId.
 * The hot-path TypingState (currentIndex, errors, text) lives in a useRef
 * inside useTypingSession — bypassing Zustand's notification cycle entirely.
 */
interface TypingStoreState {
  phase: SessionPhase;
  wpm: number;
  cpm: number;
  accuracy: number;
  errorCount: number;
  elapsedMs: number;
  currentIndex: number;
  snippetId: string | null;

  setPhase: (phase: SessionPhase) => void;
  setMetrics: (wpm: number, cpm: number, accuracy: number, errorCount: number, elapsedMs: number, currentIndex: number) => void;
  setSnippetId: (id: string | null) => void;
  reset: () => void;
}

const initialState = {
  phase: 'idle' as SessionPhase,
  wpm: 0,
  cpm: 0,
  accuracy: 100,
  errorCount: 0,
  elapsedMs: 0,
  currentIndex: 0,
  snippetId: null,
};

export const useTypingStore = create<TypingStoreState>((set) => ({
  ...initialState,

  setPhase: (phase) => set({ phase }),

  setMetrics: (wpm, cpm, accuracy, errorCount, elapsedMs, currentIndex) =>
    set({ wpm, cpm, accuracy, errorCount, elapsedMs, currentIndex }),

  setSnippetId: (snippetId) => set({ snippetId }),

  reset: () => set(initialState),
}));
